import { render, staticRenderFns } from "./NotFoundError.vue?vue&type=template&id=77f2632d&scoped=true"
import script from "./NotFoundError.vue?vue&type=script&lang=js"
export * from "./NotFoundError.vue?vue&type=script&lang=js"
import style0 from "./NotFoundError.vue?vue&type=style&index=0&id=77f2632d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f2632d",
  null
  
)

export default component.exports